getNextSession